import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import { connect } from 'react-redux'
import { initialize } from 'redux-form'
import { bindActionCreators } from 'redux'

import { ContatoForm } from '../../components'
import * as contatoConcessionariaActionCreators from '../../redux/modules/contatoConcessionaria'
import * as funcaoActionCreators from '../../redux/modules/funcao'
import * as flashMessageActionCreators from '../../redux/modules/flashMessage'

import { mapToDropdown } from '../../utils/parse'

class ContatoConcessionariaFormContainer extends Component {
  static propTypes = {
    id: PropTypes.string,
    initialize: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    concessionaria: PropTypes.object,

    fetchContatoConcessionaria: PropTypes.func.isRequired,
    createContatoConcessionaria: PropTypes.func.isRequired,
    updateContatoConcessionaria: PropTypes.func.isRequired,

    funcaoDropdown: PropTypes.array.isRequired,
    fetchMultipleFuncao: PropTypes.func.isRequired,

    showSuccessfulFlashMessage: PropTypes.func.isRequired,
    showErrorFlashMessage: PropTypes.func.isRequired,
    shouldHideFlashMessage: PropTypes.bool.isRequired,
    hideFlashMessage: PropTypes.func.isRequired,

    error: PropTypes.object,
    isLoading: PropTypes.bool,
  }

  async componentDidMount () {
    await this.props.fetchMultipleFuncao()
    if (this.props.id) {
      const contato = await this.props.fetchContatoConcessionaria(this.props.id)
      this.props.initialize('ContatoForm', { contato })
    }
  }

  handleUpdate = async (contatoConcessionaria) => {
    const concessionariaId = this.props.concessionaria.id

    if (await this.props.updateContatoConcessionaria(this.props.id, contatoConcessionaria)) {
      this.props.showSuccessfulFlashMessage('', 'update')
      this.props.history.push(`/concessionarias/${concessionariaId}/contatos`)
    } else {
      this.props.showErrorFlashMessage('', 'update', this.props.error)
    }
  }

  handleCreate = async (contatoConcessionaria) => {
    const concessionariaId = this.props.concessionaria.id

    if (await this.props.createContatoConcessionaria(concessionariaId, contatoConcessionaria)) {
      this.props.showSuccessfulFlashMessage('', 'create')
      this.props.history.push(`/concessionarias/${concessionariaId}/contatos`)
    } else {
      this.props.showErrorFlashMessage('', 'create', this.props.error)
    }
  }

  handleSubmitResource = async (contatoConcessionaria) => {
    if (this.props.id) {
      this.handleUpdate(contatoConcessionaria)
    } else {
      this.handleCreate(contatoConcessionaria)
    }
  }

  componentWillUnmount () {
    if (this.props.shouldHideFlashMessage)
      this.props.hideFlashMessage()
  }

  render () {
    return (
      <ContatoForm titleAs='h3' noPadded
        funcaoDropdown={this.props.funcaoDropdown}
        onSubmit={(contatoConcessionaria) => this.handleSubmitResource(contatoConcessionaria)}
        isLoading={this.props.isLoading} />
    )
  }
}

function mapStateToProps ({contatoConcessionaria, funcao, status, flashMessage}, {match}) {
  const { id } = match.params

  const funcaoDropdown = mapToDropdown(
    funcao,
    e => e.get('id'),
    e => e.get('nome')
  )

  if (id) {
    return {
      id,
      contatoConcessionaria: contatoConcessionaria.get('id'),
      funcaoDropdown,
      error: status.getIn(['contatoConcessionaria', 'error']),
      isLoading: status.getIn(['contatoConcessionaria', 'isLoading']),
      shouldHideFlashMessage: flashMessage.get('isError'),
    }
  }
  return {
    funcaoDropdown,
    error: status.getIn(['contatoConcessionaria', 'error']),
    isLoading: status.getIn(['contatoConcessionaria', 'isLoading']),
    shouldHideFlashMessage: flashMessage.get('isError'),
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...contatoConcessionariaActionCreators,
    ...funcaoActionCreators,
    ...flashMessageActionCreators,
    ...{initialize},
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ContatoConcessionariaFormContainer))
